import Image from '@/components/UI/Image';
import Input from '@/components/UI/Input';
import EFDelete from '@/components/UI/svg/Icons/EFDelete';
import { collectInfoSubmit } from '@/service/common';
import { useGlobal } from '@/utils/useGlobal';
import { Button, Checkbox, DatePicker, Form, Modal, Select } from 'antd';
import moment from 'moment';
import style from './index.module.scss';
export const SHOW_ADDED_TWO_QUESTION_SITES = ['us', 'ca'];

const geAndUsStates: any = {
    us: [
        {
            name: 'Alaska',
        },
        {
            name: 'Alabama',
        },
        {
            name: 'Arkansas',
        },
        {
            name: 'Arizona',
        },
        {
            name: 'California',
        },
        {
            name: 'Colorado',
        },
        {
            name: 'Connecticut',
        },
        {
            name: 'District of Columbia',
        },
        {
            name: 'Delaware',
        },
        {
            name: 'Florida',
        },
        {
            name: 'Georgia',
        },
        {
            name: 'Hawaii',
        },
        {
            name: 'Iowa',
        },
        {
            name: 'Idaho',
        },
        {
            name: 'Illinois',
        },
        {
            name: 'Indiana',
        },
        {
            name: 'Kansas',
        },
        {
            name: 'Kentucky',
        },
        {
            name: 'Louisiana',
        },
        {
            name: 'Massachusetts',
        },
        {
            name: 'Maryland',
        },
        {
            name: 'Maine',
        },
        {
            name: 'Michigan',
        },
        {
            name: 'Minnesota',
        },
        {
            name: 'Missouri',
        },
        {
            name: 'Mississippi',
        },
        {
            name: 'Montana',
        },
        {
            name: 'North Carolina',
        },
        {
            name: 'North Dakota',
        },
        {
            name: 'Nebraska',
        },
        {
            name: 'New Hampshire',
        },
        {
            name: 'New Jersey',
        },
        {
            name: 'New Mexico',
        },
        {
            name: 'Nevada',
        },
        {
            name: 'New York',
        },
        {
            name: 'Ohio',
        },
        {
            name: 'Oklahoma',
        },
        {
            name: 'Oregon',
        },
        {
            name: 'Pennsylvania',
        },
        {
            name: 'Puerto Rico',
        },
        {
            name: 'Rhode Island',
        },
        {
            name: 'South Carolina',
        },
        {
            name: 'South Dakota',
        },
        {
            name: 'Tennessee',
        },
        {
            name: 'Texas',
        },
        {
            name: 'Utah',
        },
        {
            name: 'Virginia',
        },
        {
            name: 'Vermont',
        },
        {
            name: 'Washington',
        },
        {
            name: 'Wisconsin',
        },
        {
            name: 'West Virginia',
        },
        {
            name: 'Wyoming',
        },
    ],
    de: [
        {
            name: 'Baden-Württemberg',
        },
        {
            name: 'Bavaria(Bayern)',
        },
        {
            name: 'Berlin',
        },
        {
            name: 'Brandenburg',
        },
        {
            name: 'Bremen',
        },
        {
            name: 'Hamburg',
        },
        {
            name: 'Hesse(Hessen)',
        },
        {
            name: 'Lower Saxony (Niedersachsen)',
        },
        {
            name: 'Mecklenburg-Vorpommern',
        },
        {
            name: 'North Rhine-Westphalia (Nordrhein-Westfalen)',
        },
        {
            name: 'Rhineland-Palatinate(Rheinland-Pfalz)',
        },
        {
            name: 'Saarland',
        },
        {
            name: 'Saxony(Sachsen)',
        },
        {
            name: 'Saxony-Anhalt (Sachsen-Anhalt)',
        },
        {
            name: 'Schleswig-Holstein',
        },
        {
            name: 'Thuringia(Thüringen)',
        },
    ],
    fr: [
        {
            name: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Bretagne',
        },
        {
            name: 'Centre-Val de Loire',
        },
        {
            name: 'Corse',
        },
        {
            name: 'Grand Est',
        },
        {
            name: 'Hauts-de-France',
        },
        {
            name: 'Île-de-France',
        },
        {
            name: 'Normandie',
        },
        {
            name: 'Nouvelle-Aquitaine',
        },
        {
            name: 'Occitanie',
        },
        {
            name: 'Pays de la Loire',
        },
        {
            name: "Provence-Alpes-Côte d'Azur",
        },
    ],
    uk: [
        {
            name: 'North East (England)',
        },
        {
            name: 'North West (England)',
        },
        {
            name: 'Yorkshire and The Humber',
        },
        {
            name: 'East Midlands (England)',
        },
        {
            name: 'West Midlands (England)',
        },
        {
            name: 'East of England',
        },
        {
            name: 'London',
        },
        {
            name: 'South East (England)',
        },
        {
            name: 'South West (England)',
        },
        {
            name: 'Scotland',
        },
        {
            name: 'Wales',
        },
        {
            name: 'Northern Ireland',
        },
    ],
    ca: [
        {
            name: 'Alberta',
        },
        {
            name: 'British Columbia',
        },
        {
            name: 'Manitoba',
        },
        {
            name: 'New Brunswick',
        },
        {
            name: 'Newfoundland and Labrador',
        },
        {
            name: 'Northwest Territories',
        },
        {
            name: 'Nova Scotia',
        },
        {
            name: 'Nunavut',
        },
        {
            name: 'Ontario',
        },
        {
            name: 'Prince Edward Island',
        },
        {
            name: 'Quebec',
        },
        {
            name: 'Saskatchewan',
        },
        {
            name: 'Yukon',
        },
    ],
    au: [
        {
            name: 'Australian Capital Territory',
        },
        {
            name: 'New South Wales',
        },
        {
            name: 'Northern Territory',
        },
        {
            name: 'Queensland',
        },
        {
            name: 'South Australia',
        },
        {
            name: 'Tasmania',
        },
        {
            name: 'Victoria',
        },
        {
            name: 'Western Australia',
        },
    ],
    jp: [
        {
            name: '北海道',
        },
        {
            name: '青森県',
        },
        {
            name: '岩手県',
        },
        {
            name: '宮城県',
        },
        {
            name: '秋田県',
        },
        {
            name: '山形県',
        },
        {
            name: '福島県',
        },
        {
            name: '茨城県',
        },
        {
            name: '栃木県',
        },
        {
            name: '群馬県',
        },
        {
            name: '埼玉県',
        },
        {
            name: '千葉県',
        },
        {
            name: '東京都',
        },
        {
            name: '神奈川県',
        },
        {
            name: '新潟県',
        },
        {
            name: '富山県',
        },
        {
            name: '石川県',
        },
        {
            name: '福井県',
        },
        {
            name: '山梨県',
        },
        {
            name: '長野県',
        },
        {
            name: '岐阜県',
        },
        {
            name: '静岡県',
        },
        {
            name: '愛知県',
        },
        {
            name: '三重県',
        },
        {
            name: '滋賀県',
        },
        {
            name: '京都府',
        },
        {
            name: '大阪府',
        },
        {
            name: '兵庫県',
        },
        {
            name: '奈良県',
        },
        {
            name: '和歌山県',
        },
        {
            name: '鳥取県',
        },
        {
            name: '島根県',
        },
        {
            name: '岡山県',
        },
        {
            name: '広島県',
        },
        {
            name: '山口県',
        },
        {
            name: '徳島県',
        },
        {
            name: '香川県',
        },
        {
            name: '愛媛県',
        },
        {
            name: '福岡県',
        },
        {
            name: '佐賀県',
        },
        {
            name: '長崎県',
        },
        {
            name: '熊本県',
        },
        {
            name: '大分県',
        },
        {
            name: '宮崎県',
        },
        {
            name: '鹿児島県',
        },
        {
            name: '沖縄県',
        },
    ],
    kr: [
        {
            name: '강원도',
        },
        {
            name: '경기도',
        },
        {
            name: '경상남도',
        },
        {
            name: '경상북도',
        },
        {
            name: '광주광역시',
        },
        {
            name: '대구광역시',
        },
        {
            name: '부산광역시',
        },
        {
            name: '서울특별시',
        },
        {
            name: '세종특별자치시',
        },
        {
            name: '울산광역시',
        },
        {
            name: '인천광역시',
        },
        {
            name: '전라남도',
        },
        {
            name: '전라북도',
        },
        {
            name: '제주특별자치도',
        },
        {
            name: '충청남도',
        },
        {
            name: '충청북도',
        },
        {
            name: '대전광역시',
        },
    ],
    it: [
        { name: 'Abruzzo' },
        { name: "Valle d'Aosta" },
        { name: 'Puglia' },
        { name: 'Basilicata' },
        { name: 'Calabria' },
        { name: 'Campania' },
        { name: 'Emilia-Romagna' },
        { name: 'Furlanija-Julijska Krajina/Friûl-Vignesie Julie' },
        { name: 'Lazio' },
        { name: 'Liguria' },
        { name: 'Lombardia' },
        { name: 'Marche' },
        { name: 'Molise' },
        { name: 'Piemonte' },
        { name: 'Sardegna' },
        { name: 'Sicilia' },
        { name: 'Trentino-Alto Adige/Südtirol' },
        { name: 'Toscana' },
        { name: 'Umbria' },
        { name: 'Veneto' },
    ],
    es: [
        { name: 'Andalucía' },
        { name: 'Cataluña' },
        { name: 'Comunidad de Madrid' },
        { name: 'Comunidad Valenciana' },
        { name: 'Galicia' },
        { name: 'Castilla y León' },
        { name: 'País Vasco' },
        { name: 'Castilla-La Mancha' },
        { name: 'Canarias' },
        { name: 'Región de Murcia' },
        { name: 'Aragón' },
        { name: 'Extremadura' },
        { name: 'Islas Baleares' },
        { name: 'Principado de Asturias' },
        { name: 'Comunidad Foral de Navarra' },
        { name: 'Cantabria' },
        { name: 'La Rioja' },
        { name: 'Melilla' },
        { name: 'Ceuta' },
    ],
};

const timeRangeList = [
    {
        text: '10:00 - 11:00',
        key: 't1',
    },
    {
        text: '11:00 - 12:00',
        key: 't2',
    },
    {
        text: '12:00 - 13:00',
        key: 't3',
    },
    {
        text: '13:00 - 14:00',
        key: 't4',
    },
    {
        text: '14:00 - 15:00',
        key: 't5',
    },
    {
        text: '15:00 - 16:00',
        key: 't6',
    },
    {
        text: '16:00 - 17:00',
        key: 't7',
    },
];

const europeAndUk = ['uk', 'de', 'fr'];

const applicationScenceMap: any = {
    uk: [
        {
            label: 'Vans/RVs/Trailers',
            value: 1,
        },
        {
            label: 'Off-grid Living',
            value: 2,
        },
        {
            label: 'Other',
            value: 3,
        },
    ],
    de: [
        {
            label: 'Vans/Wohnmobile/Anhänger',
            value: 1,
        },
        {
            label: 'Netzunabhängiges Wohnen',
            value: 2,
        },
        {
            label: 'Andere',
            value: 3,
        },
    ],
    fr: [
        {
            label: 'Vans/Camping-cars/Caravanes',
            value: 1,
        },
        {
            label: 'Vie hors réseau',
            value: 2,
        },
        {
            label: 'Autres',
            value: 3,
        },
    ],
    it: [
        {
            label: 'Furgoni/camper/carovane',
            value: 1,
        },
        {
            label: 'Vivere fuori rete',
            value: 2,
        },
        {
            label: 'Altro',
            value: 3,
        },
    ],
    es: [
        {
            label: 'Furgonetas / autocaravanas / caravanas',
            value: 1,
        },
        {
            label: 'Vida fuera de la red',
            value: 2,
        },
        {
            label: 'Otro',
            value: 3,
        },
    ],
};

const siteMap: any = {
    us: 'en-us',
    ca: 'en-ca',
    uk: 'en-uk',
    eu: 'en-eu',
    za: 'en-za',
    au: 'en-au',
    de: 'de-de',
    fr: 'fr-fr',
    es: 'es-es',
    it: 'it-it',
    jp: 'ja-jp',
    kr: 'ko-kr',
    cn: 'zh-cn',
    ru: 'ru-ru',
    cis: 'ru-cis',
    nl: 'nl-nl',
    tw: 'zh-tw',
};

export default function InfoCollection({ cbFunc, activityId, isRecommend, isCalculator }: any) {
    const { useLang, useState, Link, useEffect, useRouter, gtm } = useGlobal();

    const { locale } = useRouter();

    const { t } = isRecommend ? useLang('powerkitsrecommend') : isCalculator ? useLang('shared') : useLang('ecoflowpowerkitsseries');

    const [isLoading, setIsLoading] = useState(false);

    const [stateList, setStateList] = useState([]);

    const countryList = [
        {
            text: 'United States',
            shortName: 'us',
            key: '1',
        },
        {
            text: 'Germany',
            shortName: 'de',
            key: '2',
        },
        {
            text: 'France',
            shortName: 'fr',
            key: '3',
        },
        {
            text: 'Canada',
            shortName: 'ca',
            key: '4',
        },
        {
            text: 'United Kingdom',
            shortName: 'uk',
            key: '5',
        },
        {
            text: 'Australia',
            shortName: 'au',
            key: '6',
        },
        {
            text: 'Japan',
            shortName: 'jp',
            key: '7',
        },
        {
            text: 'Korea',
            shortName: 'kr',
            key: '8',
        },
        {
            text: 'Italy',
            shortName: 'it',
            key: '9',
        },
        {
            text: 'Spain',
            shortName: 'es',
            key: '10',
        },
    ];
    // const [countryList, setCountryList] = useState([])

    const [canSubmit, setCanSubmit] = useState(false);

    const [canScrollEl, setCanScrollEl] = useState('elone');

    const validateEmail = () => {
        return {
            validator: async (_: any, value: any) => {
                const regx = /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;

                if (!value || !value.trim()) {
                    return Promise.reject(t('presale.preorder.email_empty'));
                }
                if (!regx.test(value)) {
                    return Promise.reject(t('presale.preorder.email_error_tips'));
                }

                return Promise.resolve();
            },
        };
    };

    const disabledDate = (current: any) => {
        // Can not select days before today and today
        return current && current < moment().endOf('day').valueOf() + 48 * 60 * 60 * 1000;
    };

    const [selectOpen, setSelectOpen] = useState({
        countryOpen: false,
        provinceOpen: false,
        cityOpen: false,
        appScenOpen: false,
    });

    const onStateChange = (e: any) => {
        const { value } = e;
        form.setFieldsValue({
            city: undefined,
        });
    };

    const onFinish = async (values: any) => {
        const { firstname, lastname, email, phone, country, state, city, callTimeOne, callTimeOneRange, callTimeTwo, callTimeTwoRange, applicationSence } =
            values;
        if (!canSubmit) return;

        const params = {
            firstName: firstname.trim(),
            lastName: lastname.trim(),
            email: email.trim(),
            phone: phone.trim(),
            country: country && country.value ? country.label : '',
            state: state && state.value ? state.label : '',
            city: city.trim(),
            callTimeOne: callTimeOne.format('YYYY-MM-DD'),
            callTimeOneRange: callTimeOneRange.label,
            callTimeTwo: callTimeTwo.format('YYYY-MM-DD'),
            callTimeTwoRange: callTimeTwoRange.label,
            sceneId: applicationSence && applicationSence.value ? applicationSence.value : '',
            crowdFundingId: activityId,
        };

        setIsLoading(true);

        try {
            const res: any = await collectInfoSubmit(params);

            setIsLoading(false);

            if (['us', 'ca', 'de', 'fr', 'uk', 'jp', 'it', 'es'].includes(locale)) {
                window?.fbq && window?.fbq('track', 'CompleteRegistration');
            }
            if (['au'].includes(locale)) {
                window?.fbq && window?.fbq('track', 'CompleteRegistration');
            }

            if (res.code === '0') {
                cbFunc({ status: 'success' });
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'pre_order_submit',
                    button_name: 'submit',
                    status: 'success',
                });
                form.resetFields();
            } else {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'pre_order_submit',
                    button_name: 'submit',
                    status: 'fail',
                });
                //message.error(res.message)
                Modal.error({
                    //title: 'This is a notification message',
                    content: res.message,
                    wrapClassName: style.infoCollectionWin,
                });
            }
        } catch (err: any) {
            setIsLoading(false);
            console.log('err:', err);
        }
    };

    const getStateList = async (id: number, shortName: string) => {
        const tempStateList = geAndUsStates[shortName];
        const temp = tempStateList.map((item: any, indx: number) => ({
            key: id + indx,
            text: item.name,
        }));

        setStateList(temp);
    };

    // // 监听所有可滚动元素的滚动事件
    // [].forEach.call(scrollEl, (el: HTMLElement) => {
    //     let initialY = 0;
    //     el.addEventListener('touchstart', e => {
    //         if (e.targetTouches.length === 1) {
    //             // 单点滑动
    //             initialY = e.targetTouches[0].clientY;
    //         }
    //     });
    //     el.addEventListener('touchmove', e => {
    //         if (e.targetTouches.length === 1) {
    //             // 单点滑动
    //             const clientY = e.targetTouches[0].clientY - initialY;
    //             if (el.scrollTop + el.clientHeight >= el.scrollHeight && clientY < 0) {
    //                 // 向下滑至底部
    //                 return e.preventDefault();
    //             } if (el.scrollTop <= 0 && clientY > 0) {
    //                 // 向上滑至顶部
    //                 return e.preventDefault();
    //             }
    //         }
    //     });
    // });

    const onCountryChange = (e: any) => {
        const { value } = e;

        // select组件重置值，也会把placeholder清除，所以提前获取值判断是否存在值
        form.setFieldsValue({
            state: undefined,
        });

        form.setFieldsValue({
            city: undefined,
        });

        const target = countryList.filter((item: any) => item.key === value);
        getStateList(value, target[0].shortName);
    };

    const checkboxChange = (e) => {
        if (e.target.checked === true) {
            setCanSubmit(true);
        } else {
            setCanSubmit(false);
        }
    };

    useEffect(() => {
        // let initialY = 0;
        // el.addEventListener('touchstart', e => {
        //     if (e.targetTouches.length === 1) {
        //         // 单点滑动
        //         initialY = e.targetTouches[0].clientY;
        //     }
        // });
        // el.addEventListener('touchmove', e => {
        //     if (e.targetTouches.length === 1) {
        //         // 单点滑动
        //         const clientY = e.targetTouches[0].clientY - initialY;
        //         if (el.scrollTop + el.clientHeight >= el.scrollHeight && clientY < 0) {
        //             // 向下滑至底部
        //             return e.preventDefault();
        //         } if (el.scrollTop <= 0 && clientY > 0) {
        //             // 向上滑至顶部
        //             return e.preventDefault();
        //         }
        //     }
        // });
        const ele = document.querySelector('.form-content');

        const touchMoveFunc = (e) => {
            const excludeEl = document.querySelector('.can-scroll');
            // console.log(excludeEl?.contains(e.target))
            const isExclude = excludeEl?.contains(e.target);
            if (isExclude) {
                return true;
            }
            e.preventDefault();
        };
        ele?.addEventListener('touchmove', touchMoveFunc, { passive: false });

        return function () {
            document.removeEventListener('touchmove', touchMoveFunc);
        };
    }, []);

    const [form] = Form.useForm();

    return (
        <div className={style.infoCollection}>
            <div className={`${canScrollEl === 'elone' ? 'can-scroll ' : ''}form-content`}>
                <div
                    onClick={() => {
                        cbFunc({ status: 'close' });
                    }}
                    className="close-icon"
                >
                    <EFDelete />
                </div>
                <div className="top-title">{t('presale.preorder.infocollect_title')}</div>
                <div className="form-wrapper">
                    <Form name="cooperation" form={form} layout="vertical" onFinish={onFinish}>
                        <div className="two-colums">
                            <Form.Item
                                label={t('presale.preorder.firstname_text')}
                                name="firstname"
                                required
                                rules={[
                                    () => ({
                                        validator(_: any, value: any) {
                                            const regx = /^((?!\d|\+|&|=|\_|'|-|,|<|>|\.{2,}).){1,50}$/;
                                            if (!value || !value.trim()) {
                                                return Promise.reject(t('presale.preorder.firstname_empty'));
                                            }
                                            if (value && value.length > 30) return Promise.reject(t('presale.preorder.firstname_invalid'));

                                            if (!regx.test(value)) {
                                                return Promise.reject(t('presale.preorder.firstname_invalid'));
                                            }

                                            return Promise.resolve();
                                        },
                                    }),
                                ]}
                            >
                                <Input
                                    className="default-input"
                                    placeholder={t('presale.preorder.firstname_text')}
                                    aria-label={t('presale.preorder.firstname_text')}
                                />
                            </Form.Item>
                            <Form.Item
                                label={t('presale.preorder.lastname_text')}
                                name="lastname"
                                required
                                rules={[
                                    () => ({
                                        validator(_: any, value: any) {
                                            const regx = /^((?!\d|\+|&|=|\_|'|-|,|<|>|\.{2,}).){1,50}$/;
                                            if (!value || !value.trim()) {
                                                return Promise.reject(t('presale.preorder.lastname_empty'));
                                            }
                                            if (value && value.length > 30) return Promise.reject(t('presale.preorder.lastname_invalid'));

                                            if (!value || !regx.test(value)) {
                                                return Promise.reject(t('presale.preorder.lastname_invalid'));
                                            }

                                            return Promise.resolve();
                                        },
                                    }),
                                ]}
                            >
                                <Input
                                    className="default-input"
                                    placeholder={t('presale.preorder.lastname_text')}
                                    aria-label={t('presale.preorder.lastname_text')}
                                />
                            </Form.Item>
                        </div>
                        <div className="two-colums">
                            <Form.Item
                                label={t('presale.preorder.country_text')}
                                name="country"
                                required
                                rules={[
                                    {
                                        validator: (rule, value) => {
                                            if (!value) {
                                                return Promise.reject(t('presale.preorder.country_empty'));
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <Select
                                    className={`${canScrollEl === 'eltwo' ? 'can-scroll ' : ''}ef-comp-selector`}
                                    // className="ef-comp-selector"
                                    placeholder={t('presale.preorder.country_text')}
                                    onChange={onCountryChange}
                                    optionFilterProp="children"
                                    // showSearch
                                    onDropdownVisibleChange={(open) => {
                                        if (open) {
                                            // console.log("setCanScrollEl===eltwo")
                                            setCanScrollEl('eltwo');
                                        } else {
                                            // console.log("setCanScrollEl1===elone")
                                            if (canScrollEl === 'eltwo') {
                                                setCanScrollEl('elone');
                                            }
                                        }
                                        setSelectOpen({
                                            ...selectOpen,
                                            ...{
                                                countryOpen: open,
                                            },
                                        });
                                    }}
                                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                    suffixIcon={
                                        <div
                                            style={{
                                                transform: `rotate(${selectOpen.countryOpen ? '90deg' : '0deg'})`,
                                            }}
                                        >
                                            <Image src="/icons/arrow-black.svg" width={20} height={20} alt={t('site_dealer_icon')} />
                                        </div>
                                    }
                                    dropdownClassName="ef-select-item"
                                    labelInValue
                                >
                                    {countryList?.map((item: any) => (
                                        <Select.Option value={item.key} key={item.key}>
                                            {item.text}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label={t('presale.preorder.state_text')}
                                name="state"
                                required
                                rules={[
                                    {
                                        validator: (rule, value) => {
                                            if (!value) {
                                                return Promise.reject(t('presale.preorder.state_empty'));
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <Select
                                    className={`${canScrollEl === 'elthree' ? 'can-scroll ' : ''}ef-comp-selector`}
                                    // className="ef-comp-selector"
                                    onChange={onStateChange}
                                    placeholder={t('presale.preorder.state_text')}
                                    onDropdownVisibleChange={(open) => {
                                        if (open) {
                                            // console.log("setCanScrollEl===elthree")
                                            setCanScrollEl('elthree');
                                        } else {
                                            // console.log("setCanScrollEl1===elone")
                                            if (canScrollEl === 'elthree') {
                                                setCanScrollEl('elone');
                                            }
                                        }
                                        setSelectOpen({
                                            ...selectOpen,
                                            ...{
                                                provinceOpen: open,
                                            },
                                        });
                                    }}
                                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                    suffixIcon={
                                        <div
                                            style={{
                                                transform: `rotate(${selectOpen.provinceOpen ? '90deg' : '0deg'})`,
                                            }}
                                        >
                                            <Image src="/icons/arrow-black.svg" width={20} height={20} alt={t('site_dealer_icon')} />
                                        </div>
                                    }
                                    dropdownClassName="ef-select-item"
                                    labelInValue
                                >
                                    {stateList?.map((item: any) => (
                                        <Select.Option value={item.key} key={item.key}>
                                            {item.text}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                        <div className="two-colums">
                            <Form.Item
                                label={t('presale.preorder.city_text')}
                                name="city"
                                required
                                rules={[
                                    () => ({
                                        validator(_: any, value: any) {
                                            if (!value || !value.trim()) {
                                                return Promise.reject(t('presale.preorder.city_empty'));
                                            }
                                            return Promise.resolve();
                                        },
                                    }),
                                ]}
                            >
                                <Input
                                    className="default-input vertical-line"
                                    placeholder={t('presale.preorder.city_text')}
                                    aria-label={t('presale.preorder.city_text')}
                                />
                            </Form.Item>

                            <Form.Item label={t('presale.preorder.email_text')} name="email" rules={[validateEmail]} validateTrigger="onBlur" required>
                                <Input className="default-input" placeholder={t('presale.preorder.email_text')} aria-label={t('presale.preorder.email_text')} />
                            </Form.Item>
                        </div>

                        <div className="two-colums">
                            <Form.Item
                                label={t('presale.preorder.phone_text')}
                                name="phone"
                                required
                                rules={[
                                    () => ({
                                        validator(_: any, value: any) {
                                            const regx = /^[0-9+\-\s]{7,20}$/;
                                            if (!value || !value.trim()) {
                                                return Promise.reject(t('presale.preorder.phone_empty'));
                                            }
                                            if (!regx.test(value)) {
                                                return Promise.reject(t('presale.preorder.phone_error_tips'));
                                            }

                                            return Promise.resolve();
                                        },
                                    }),
                                ]}
                            >
                                <Input
                                    className="default-input vertical-line"
                                    placeholder={t('presale.preorder.phone_text')}
                                    aria-label={t('presale.preorder.phone_text')}
                                    maxLength="50"
                                />
                            </Form.Item>
                        </div>

                        {europeAndUk.includes(locale) && (
                            <div className="application-scence">
                                <Form.Item
                                    label={t('presale.preorder.application_scenarios')}
                                    name="applicationSence"
                                    required
                                    rules={[
                                        {
                                            validator: (rule, value) => {
                                                if (!value) {
                                                    return Promise.reject(t('presale.preorder.application_scenarios_empty'));
                                                }
                                                return Promise.resolve();
                                            },
                                        },
                                    ]}
                                >
                                    <Select
                                        className={`${canScrollEl === 'elsix' ? 'can-scroll ' : ''}ef-comp-selector`}
                                        // className="ef-comp-selector"
                                        placeholder={t('presale.preorder.application_scenarios')}
                                        // onChange={onAppSenceChange}
                                        optionFilterProp="children"
                                        // showSearch
                                        onDropdownVisibleChange={(open) => {
                                            if (open) {
                                                // console.log("setCanScrollEl===eltwo")
                                                setCanScrollEl('elsix');
                                            } else {
                                                // console.log("setCanScrollEl1===elone")
                                                if (canScrollEl === 'elsix') {
                                                    setCanScrollEl('elone');
                                                }
                                            }
                                            setSelectOpen({
                                                ...selectOpen,
                                                ...{
                                                    appScenOpen: open,
                                                },
                                            });
                                        }}
                                        getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                        suffixIcon={
                                            <div
                                                style={{
                                                    transform: `rotate(${selectOpen.appScenOpen ? '90deg' : '0deg'})`,
                                                }}
                                            >
                                                <Image src="/icons/arrow-black.svg" width={20} height={20} alt={t('site_dealer_icon')} />
                                            </div>
                                        }
                                        dropdownClassName="ef-select-item"
                                        labelInValue
                                    >
                                        {applicationScenceMap[locale]?.map((item: any) => (
                                            <Select.Option value={item.value} key={item.label}>
                                                {item.label}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </div>
                        )}

                        <div className="rangetime-tips">{t('presale.preorder.choose_time_tips')}</div>
                        <div className="two-colums">
                            <Form.Item
                                label={t('presale.preorder.choose_time_one')}
                                name="callTimeOne"
                                required
                                rules={[
                                    {
                                        validator: (rule, value) => {
                                            if (!value) {
                                                return Promise.reject(t('presale.preorder.date_empty'));
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <DatePicker
                                    picker="date"
                                    inputReadOnly
                                    className="date-picker"
                                    placeholder={t('presale.preorder.time_date')}
                                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                    disabledDate={disabledDate}
                                />
                            </Form.Item>
                            <Form.Item
                                label=" "
                                name="callTimeOneRange"
                                required
                                className="time-item"
                                rules={[
                                    {
                                        validator: (rule, value) => {
                                            if (!value) {
                                                return Promise.reject(t('presale.preorder.time_empty'));
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <Select
                                    className={`${canScrollEl === 'elfour' ? 'can-scroll ' : ''}ef-comp-selector`}
                                    placeholder={t('presale.preorder.time_time')}
                                    onDropdownVisibleChange={(open) => {
                                        if (open) {
                                            // console.log("setCanScrollEl===elfour")
                                            setCanScrollEl('elfour');
                                        } else {
                                            if (canScrollEl === 'elfour') {
                                                // console.log("setCanScrollEl1===elone")
                                                setCanScrollEl('elone');
                                            }
                                        }
                                        setSelectOpen({
                                            ...selectOpen,
                                            ...{
                                                provinceOpen: open,
                                            },
                                        });
                                    }}
                                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                    suffixIcon={
                                        <div
                                            style={{
                                                transform: `rotate(${selectOpen.provinceOpen ? '90deg' : '0deg'})`,
                                            }}
                                        >
                                            <Image src="/icons/arrow-black.svg" width={20} height={20} alt={t('site_dealer_icon')} />
                                        </div>
                                    }
                                    dropdownClassName="ef-select-item"
                                    labelInValue
                                >
                                    {timeRangeList?.map((item: any) => (
                                        <Select.Option value={item.text} key={item.key}>
                                            {item.text}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>

                        <div className="two-colums">
                            <Form.Item
                                label={t('presale.preorder.choose_time_another')}
                                name="callTimeTwo"
                                required
                                rules={[
                                    {
                                        validator: (rule, value) => {
                                            if (!value) {
                                                return Promise.reject(t('presale.preorder.date_empty'));
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <DatePicker
                                    picker="date"
                                    className="date-picker"
                                    inputReadOnly
                                    placeholder={t('presale.preorder.time_date')}
                                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                    disabledDate={disabledDate}
                                />
                            </Form.Item>
                            <Form.Item
                                label=" "
                                name="callTimeTwoRange"
                                required
                                className="time-item"
                                rules={[
                                    {
                                        validator: (rule, value) => {
                                            if (!value) {
                                                return Promise.reject(t('presale.preorder.time_empty'));
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <Select
                                    className={`${canScrollEl === 'elfive' ? 'can-scroll ' : ''}ef-comp-selector`}
                                    placeholder={t('presale.preorder.time_time')}
                                    onDropdownVisibleChange={(open) => {
                                        if (open) {
                                            // console.log("setCanScrollEl===five")
                                            setCanScrollEl('elfive');
                                        } else {
                                            // console.log("setCanScrollEl1===elone")
                                            if (canScrollEl === 'elfive') {
                                                setCanScrollEl('elone');
                                            }
                                        }
                                        setSelectOpen({
                                            ...selectOpen,
                                            ...{
                                                provinceOpen: open,
                                            },
                                        });
                                    }}
                                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                    suffixIcon={
                                        <div
                                            style={{
                                                transform: `rotate(${selectOpen.provinceOpen ? '90deg' : '0deg'})`,
                                            }}
                                        >
                                            <Image src="/icons/arrow-black.svg" width={20} height={20} alt={t('site_dealer_icon')} />
                                        </div>
                                    }
                                    dropdownClassName="ef-select-item"
                                    labelInValue
                                >
                                    {timeRangeList?.map((item: any) => (
                                        <Select.Option value={item.key} key={item.key}>
                                            {item.text}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>

                        <div className="terms-checkbox">
                            <Form.Item name="agreement" valuePropName="checked">
                                <Checkbox onChange={checkboxChange}>
                                    {t('presale.preorder.policy_terms_one')}
                                    <Link target="_blank" href={`https://account.ecoflow.com/agreement/${siteMap[locale] || siteMap.us}/PrivacyPolicy.html`}>
                                        {t('presale.preorder.policy_terms_two')}
                                    </Link>
                                    {t('presale.preorder.policy_terms_three')}
                                    <Link target="_blank" href={`https://account.ecoflow.com/agreement/${siteMap[locale] || siteMap.us}/TermsOfUse.html`}>
                                        {t('presale.preorder.policy_terms_four')}
                                    </Link>
                                    {t('presale.preorder.policy_terms_five')}
                                </Checkbox>
                            </Form.Item>
                        </div>

                        <div className="sub-btn" style={{ textAlign: 'center' }}>
                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className={`${canSubmit ? 'can-submit ' : ''}submit-btn`}
                                    disabled={!canSubmit}
                                    loading={isLoading}
                                    aria-label={t('presale.preorder.submit_text')}
                                >
                                    {t('presale.preorder.submit_text')}
                                </Button>
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
}
